import React from 'react'

const ToolbarButtonGroup = (props) => (
  <div className="toolbar-btn-group">
    { props.children }
  </div>
)
export default ToolbarButtonGroup
